import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

const ACTION_TYPES = {
  BUTTON: 'button',
  LINK: 'link'
};

export default function ActionButton({
  children,
  iconName,
  iconSize,
  iconClassName,
  className,
  type,
  ...buttonProps
}) {
  const Component = type === ACTION_TYPES.LINK ? 'a' : 'button';

  return (
    <Component
      type={type === ACTION_TYPES.BUTTON ? 'button' : null}
      className={classnames('flex items-center gap-8', className)}
      {...buttonProps}
    >
      <Icon
        className={iconClassName}
        name={iconName}
        height={iconSize}
        width={iconSize}
      />
      {children && <span>{children}</span>}
    </Component>
  );
}

ActionButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  type: PropTypes.string
};

ActionButton.defaultProps = {
  children: null,
  className: null,
  iconClassName: null,
  iconSize: '24px',
  type: ACTION_TYPES.BUTTON
};
